<template>
  <q-dialog
    v-model="dialog"
    persistent
    style="max-width: 600px"
    class="custom-font text-uppercase"
  >
    <q-card class="pragma-black text-white">
      <q-card-section class="q-pa-none">
        <q-toolbar class="bg-pragma text-white">
          <strong>
            <span>Detalle del ítem</span>
          </strong>
          <q-space></q-space>
          <q-btn
            flat
            icon="clear"
            @click="closeDialog()"
          ></q-btn>
        </q-toolbar>
      </q-card-section>
      <q-card-section>
        <div class="row q-gutter-y-sm">
          <div class="col-xs-6 q-pr-sm">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Cantidad
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{~~item.cantidad}}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-6 q-pl-sm">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Precio unitario
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{item.precio_unitario}}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-12">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Unidad
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{item.unidad.descripcion}}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-12">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Tipo de compra
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{getNameTipoCompra()}}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-12">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Detalle
              </q-card-section>
              <q-card-section class="q-pa-xs text-uppercase">
                {{item.detalle}}
              </q-card-section>
            </q-card>
          </div>
          <!-- Caso de reposición y fondo rotativo  -->
          <div class="col-xs-12" v-if="props.modalidad_id == 3 || props.modalidad_id == 4">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Nro. Factura / Recibo
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{item.nrofactura}}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-12" v-if="props.modalidad_id == 3 || props.modalidad_id == 4">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Fecha Factura / Recibo
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{item.fechafactura}}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-12" v-if="props.modalidad_id == 3 || props.modalidad_id == 4">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Proyecto
              </q-card-section>
              <q-card-section class="q-pa-xs text-uppercase">
                {{item.itemproyecto}}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-12" v-if="props.modalidad_id == 3 || props.modalidad_id == 4">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Proveedor
              </q-card-section>
              <q-card-section class="q-pa-xs text-uppercase">
                {{item.itemproveedor}}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-12" v-if="props.modalidad_id == 3 || props.modalidad_id == 4">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Tipo
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{item.itemtipo}}
              </q-card-section>
            </q-card>
          </div>
          <!-- Fin del caso fondo rotativo y reposición -->
          <div class="col-xs-12">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Subtotal:
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{item.precio_unitario * item.cantidad}}
              </q-card-section>
            </q-card>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import {inject, ref} from 'vue'
import moment from 'moment'

export default {
  props: ['modalidad_id'],
  setup (props) {
    // Variables reactivas y no reactivas
    const bus = inject('bus')
    const vmoment = moment

    const dialog = ref(false)
    const item = ref({
      cantidad: null,
      unidad: {
        nombre: ''
      },
      tipo_compra: {
        descripcion: ''
      },
      detalle: null,
      precio_unitario: null,
      sub_total: 0,
    })

    // Métodos y funciones del componente
    const closeDialog = () => {
      item.value = {}
      dialog.value = false
    }

    const getNameTipoCompra = () => {
      if (item.value.chosse_tipo_compra) {
        return `${item.value.chosse_tipo_compra.descripcion} > ${item.value.tipo_compra.descripcion}`
      }
      return item.value.tipo_compra.descripcion
    }

    // Creación del componente
    bus.on('openDialogDetalleItem', (obj) => {
      item.value = obj
      dialog.value = true
    })

    return {
      dialog,
      item,
      closeDialog,
      vmoment,
      props,
      getNameTipoCompra
    }
  }
}
</script>

<style>

</style>